@import "../../../../new-result-cards/generic-subcomponents/generic-card-title/generic-card-title";
@import "../../../../new-result-cards/generic-subcomponents/generic-card-thumbnail/generic-card-thumbnail";
@import "../../../../../result-page/new-result-cards/public/video-card/subcomponents/video-card-thumbnail/_video-card-thumbnail.scss";

.company__thumbnail {
  margin-right: 0px;
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.company__container {
  display: flex;
  flex-wrap: wrap;
  &-video {
    display: flex;
    justify-content: space-between;
    @media screen and (min-width: 781px) {
      flex-direction: row;
    }
    @media screen and (max-width: 780px) {
      flex-direction: column;
    }
  }
}

.company-item {
  flex: 1 0 50%;
}

.video-item {
  @media screen and (min-width: 781px) {
    max-width: 254px;
  }
  @media screen and (max-width: 780px) {
    max-width: 100%;
  }
}

.video-widget-thumbnail {
  cursor: pointer;
}

.result-card__title-link {
  h3 {
    font-size: 18px;
  }
}

.company-item__container {
  padding: 10px 10px 20px;
  box-sizing: border-box;
  a {
    text-decoration: none;
    &:hover {
      .result-card__title-link {
        text-decoration: underline;
      }
    }
  }
}

.dashboard-thumbnail-container {
  inline-size: max-content;
  margin: auto;
}

.dashboard__thumbnail {
  height: 100px;
  margin-bottom: 5px;
  width: 100px;
}

.document__label-panel {
  line-height: 22px;
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
  color: $svs-se-dark-grey;
  margin-top: 4px;
  @media (min-width: $uiaas-tablet) {
    line-height: 20px;
    font-size: 14px;
  }
}

.document__category {
  color: var(--qds-theme-signature-color-default, #008a16);

  &-accessibility {
    color: #333;
  }
}

.video-frame {
  height: 40vh;
  width: 100%;
}
.video-frame_icon {
  position: absolute;
  right: -40px;
  cursor: pointer;
}
@media (max-width: 980px) {
  .video-frame {
    width: 50vh;
  }
  .video-frame_icon {
    right: 0;
    top: -40px;
    width: 30px;
    height: 30px;
  }
}
@media (max-width: 650px) {
  .video-frame {
    width: 500px;
  }
}

@media (max-width: 500px) {
  .video-frame {
    width: 350px;
  }
}
